import View from "../framework/view";
import Server from "../server";
import template from "../../pugc/payment-element";
import {Spinner} from "./spinner";
import {scrollTo} from "../misc/utils";

export class PaymentElementView extends View {

    private readonly server = Server.instance();

    static classname = "payment-element-view";

    private clientSecret? : string;

    private stripe : any = undefined;

    private elements : any = undefined;

    private paymentElement : any = undefined;

    public submit_message = "Submit payment";

    private resolve?: (value: any | PromiseLike<any>) => void;
    private reject?: (reason?: any) => void;

    private promise : Promise<any>;

    constructor() {
        super(PaymentElementView.classname);
        this.promise = this.newPromise();
    }

    getPromise() {
        return this.promise;
    }

    newPromise() : Promise<any> {
        return this.promise = new Promise<any>((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
    }

    refresh() {
        this.clientSecret = undefined;
        this.stripe = undefined;
        this.elements = undefined;
        this.paymentElement = undefined;
        this.update();
    }

    public createIntent(dollars: number, description: string | undefined) {

        const cents = parseInt("" + (dollars * 100));

        const intent_ = this.server.createPaymentIntent(cents, description);
        const params_ = this.server.runtimeParams_;
        Promise.all([intent_, params_]).then(([secret, params]) => {

            this.elt().find(".amount").text("$" + dollars);
            description && this.elt().find(".description").text(description);

            this.elt().find("input[name='amount']").prop("disabled", true);
            const payment_form = this.elt().find("form.payment-form");
            payment_form.show();

            this.clientSecret = secret.toString();

            const publishableKey = params["wrb.client.stripe.publishable_key"];
            // @ts-ignore
            this.stripe = new Stripe(publishableKey);

            const options = {
                clientSecret: this.clientSecret,
            };

            this.elements = this.stripe.elements(options);
            this.paymentElement = this.elements.create("card");

            const uuid = this.getUuid();
            const id = `#${uuid}-payment-element`;
            const elt = this.elt().find(id)[0];

            if (this.paymentElement) {
                this.paymentElement.mount(elt);
                this.paymentElement.on("change", (evt: any) => {
                    this.paymentEvent(evt);
                })
            }

        });

        return intent_;
    }

    paymentEvent(evt: any) {
        const complete = evt.complete;
        this.elt().find(".submit-payment").prop("disabled", ! complete);
    }

    protected render0(): JQuery<HTMLElement> {

        const data = {
            submit_message: this.submit_message
        };

        const out = this.pug(template, data);

        out.find(".with-validation").validate({
            rules: {
                "amount": {
                    "required": true,
                    "number": true
                }
            }
        });

        return out;
    }

    pay() {
        this.elt().find(".status").text("");
        this.elt().find(".message").text("");

        const pop = Spinner.pushSpinner();
        const try_ = this.stripe.confirmCardPayment(this.clientSecret,
            {
                payment_method: {
                    card: this.paymentElement
                }
            });

        try_.then((x: any) => {
            console.log("TRY", x);
            const p = x.paymentIntent;
            const status = p && p.status;

            const error = x.error;
            const msg = error && error.message;

            status && this.elt().find(".status").text(status);
            msg && this.elt().find(".message").text(msg);

            if (error) {
                this.reject && this.reject(error);
            } else {
                this.resolve && this.resolve(x);
            }

        });
        try_.catch((err: any) => {
            console.log("ERR", err);
            this.elt().find(".message").text(err);
            scrollTo(this.elt().find(".message"));
            this.reject && this.reject(err);
        });
        try_.finally(() => {
            pop();
        });

        return try_;
    }

}

View.on(
    "." + PaymentElementView.classname,
    "click",
    "button.submit-payment",
    function(that: PaymentElementView, event, elt) {
        event.preventDefault();
        that.pay();
    });
